export default function assert(v, msg?, o?) {
  if (!v) {
    if (o) {
      console.log("assertion failure: \n  "  + msg, {msg,mayBeRelevant:o})
    }
    throw new Error(`Assertion Fail ${msg || ""}`)
  }
}

export type int = number